import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';

/**
 * The UTC interval of the current-or-next maintenance window (Proweb-38). The backend reduces the BF
 * maintenance configurations to this; the wording and the provider's time zone are the banner's job.
 */
export interface MaintenanceWindowInfo {
  readonly active: boolean;
  readonly startsAt: string | null;
  readonly endsAt: string | null;
}

const NO_BANNER: MaintenanceWindowInfo = {
  active: false,
  startsAt: null,
  endsAt: null,
};

/**
 * Maintenance banner state (US-018). Fail-open: any failure resolves to "no banner" rather than an error
 * state, so an unavailable maintenance-window service never degrades a provider screen (SAD-001 P-05).
 */
export function useMaintenanceWindow(): UseQueryResult<MaintenanceWindowInfo, never> {
  return useQuery<MaintenanceWindowInfo, never>({
    queryKey: ['maintenance-window'],
    queryFn: async () => {
      try {
        const response = await apiClient.get<MaintenanceWindowInfo>('/api/maintenance-window');
        return response.data;
      } catch {
        return NO_BANNER;
      }
    },
    staleTime: 60_000,
    retry: false,
  });
}
